import { render, staticRenderFns } from "./complaint.vue?vue&type=template&id=47ecf661"
import script from "./complaint.vue?vue&type=script&lang=js"
export * from "./complaint.vue?vue&type=script&lang=js"
import style0 from "./complaint.vue?vue&type=style&index=0&id=47ecf661&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports